import styled from "styled-components";
import { Container } from "../../atoms/Container";
import breakpoints from "../../../styles/breakpoints";

export const StyledContainer = styled(Container)`
  padding: 50px 0;
  text-align: center;
  ${breakpoints.smDown} {
    padding: 10px 10px;
  }
`;

export const StyledHeader = styled.h5`
  font-weight: bold;
  font-size: 28px;
  line-height: 30px;
  ${breakpoints.smDown} {
    font-size: 24px;
    line-height: 26px;
  }
  text-transform: uppercase;
`;

export const StyledImg = styled.img`
  max-width: 500px;
  padding: 20px 10px;
  ${breakpoints.smDown} {
    max-width: 100%;
  }
`;
